import { CreateOrderFormType } from 'pages/cs/create-order/types';
import {
  ENUM_INBOUND_ROLE,
  ENUM_KITCHEN_STATUS,
  ENUM_PENDING_SOURCE,
  ENUM_STATUS,
  ENUM_TRIP_STATUS,
  FCB_BRAND_TYPE,
  ENUM_ORDER_LOG_ACTIONS
} from './enum';
import { SurgeListType } from 'models/surge.model';
import { ENUM_GENDER } from 'models/user.model';
import { ExtendedFilterType, ExtendedKitchenFilterType } from 'pages/live-trips/types';

export const ROUTE_KEYS = {
  LOGIN: '/login',
  RESET_PASSWORD: '/reset-password/:token',
  SEARCH: '/search',
  CLEAR_STORAGE: '/clear-storage'
};

export const TURN_OFF_REASON = ['Items are out of stock', 'Items are expired', 'Others'];

export const LOGISTICS_ROUTE_KEYS = {
  DASHBOARD: '/',
  OVERVIEW: '/overview',
  LIVE_TRIPS: '/live-trips',
  PARTNERS: '/partners',
  SEARCH: '/search',
  SCHEDULED: '/scheduled',
  SEARCH_RESULT: '/search-result/:filterType/:filterValue',
  PAYMENT_HISTORY: '/logistics/payment-history',
  BIN: '/recently-deleted',
  ORDER_HISTORY: '/logistics/order-history',
  FCB_DELIVERIES: '/logistics/fcb-deliveries',
  SETTINGS: '/settings',
  LOCATION: '/settings/location',
  TEAM_STATS: '/logistics/team/stats',
  POLYGON_RIDERS: '/polygon-riders/:polygon_id',
  USER_PROFILE: '/user/:user_id',
  RECALLED_ORDERS: '/recalled-orders',
  EXTERNAL_RIDERS: '/external-riders',
  CLEAR_STORAGE: '/clear-storage',
  DELIVERY_MANAGMENT: '/delivery-managment'
};

export const SECURITY_ROUTE_KEYS = {
  DASHBOARD: '',
  SECURITY: '/security'
};

export const KITCHEN_ROUTE_KEYS = {
  DASHBOARD: '/',
  LIVE_TRIPS: '/live-trips',
  SEARCH: '/search',
  SEARCH_RESULT: '/search-result/:filterType/:filterValue',
  INVENTORY: '/inventory',
  MEAL_PRODUCTION_TRACKER: '/inventory/meal-production-tracker',

  TEAM_STATS: '/kitchen/team/stats',
  SETTINGS: '/kitchen/settings',
  MANAGE_TRAFFIC: '/kitchen/settings/manage-traffic',
  // KITCHEN SETTINGS
  TEAM_LIST: '/kitchen/settings/team-list',
  WEEKLY_ROSTER: '/kitchen/settings/weekly-roster',
  REVIEW_WEEKLY_ROSTER: '/kitchen/settings/weekly-roster/review',
  EDIT_WEEKLY_ROSTER: '/kitchen/settings/weekly-roster/edit',
  TEAM_OF_THE_MONTH: 'team-of-the-month',
  TOP_MEMBERS_OF_THE_MONTH: 'top-members-of-the-month',
  NOTICE_BOARD: 'notice-board',
  PACKAGING_SCREENS: '/kitchen/settings/packaging-screens',
  USER_PROFILE: '/user/:user_id',
  CLEAR_STORAGE: '/clear-storage'
};

export const CS_ROUTE_KEYS = {
  DASHBOARD: '/',
  PENDING_TASKS: '/pending-tasks',
  REVIEWS: '/reviews',
  SEARCH: '/search',
  SEARCH_RESULT: '/search-result/:filterType/:filterValue',
  NEW_ORDER: '/:type/:id',
  LIVE_TRIPS: '/live-trips',
  UPDATE_ORDER: '/order/:order_id',
  TASK_HISTORY: '/task-history',
  SETTINGS: '/cs/settings',
  // CS SETTINGS
  PROFILE: 'profile',
  BANKS: 'banks',
  PASSWORD: 'password',
  CS_REPS: 'cs-reps',
  CS_REPS_INFO: '/cs-reps/:id',
  TEAM_STATS: '/cs/team/stats',
  USER_PROFILE: '/user/:user_id',
  RECALLED_ORDERS: '/recalled-orders',
  CLEAR_STORAGE: '/clear-storage'
};

export const COKITCHEN_LOCATIONS = {
  LEKKI: 'Cokitchen Lekki'
};

export const STORAGE_KEYS = {
  TOKEN: 'token',
  USER_ID: 'id',
  EMAIL: 'email',
  FIRST_NAME: 'first_name',
  LAST_NAME: 'last_name',
  ROLE: 'role',
  COKITCHEN: 'cokitchen',
  COKITCHEN_LIST: 'cokitchen_list',
  ACTIVE_COKITCHEN: COKITCHEN_LOCATIONS.LEKKI,
  STAFF_NUMBER: 'staff_number',
  DELIVERY_POLYGONS_STATE: 'delivery-polygons',
  INDEXED_DB_NAME: 'cokitchen-logistics',
  STORE_NAME_LIVE_TRIPS: 'live-trips',
  ADMIN_ROLE: 'admin-role',
  ONLINE: 'online',
  HEADER_BRANDS: 'header_brands',
  SCREEN_DETAILS: 'screen_details',
  IS_BRAND_SPLIT_SCREEN: 'is_brand_split_screen',
  RECALLED_ORDERS: '/recalled-orders'
};

export const ORDER_STATUS: Record<ENUM_STATUS | ENUM_KITCHEN_STATUS | 'complete', any> = {
  late: {
    text: 'Late',
    bgColor: '#FEE7EA',
    textColor: '#E60A2B',
    borderColor: '#FCB6C0'
  }, // green
  unpaid: {
    text: 'Unpaid',
    bgColor: '#F5F5F5',
    borderColor: '#DEDEDE',
    textColor: '#A3A3A3'
  }, // gray
  dispatched: {
    text: 'Dispatched',
    bgColor: '#E6F5FF',
    textColor: '#0EA3FD',
    borderColor: '#81CFFE'
  }, // blue

  ongoing: {
    text: 'Ongoing',
    bgColor: '#EEF9EB',
    textColor: '#46AE31',
    borderColor: '#A8E39C'
  }, // green
  pending: {
    text: 'Pending',
    bgColor: '#F5F5F5',
    borderColor: '#DEDEDE',
    textColor: '#A3A3A3'
  }, // gray
  ready: {
    text: 'Ready',
    bgColor: '#E6F5FF',
    textColor: '#0EA3FD',
    borderColor: '#81CFFE'
  }, // blue
  processing: {
    text: 'Processing',
    bgColor: '#FEFAEB',
    textColor: '#F9C320',
    borderColor: '#FCE08D'
  }, // yellow
  complete: {
    text: 'Complete',
    bgColor: '#2c2c2c',
    textColor: '#fff',
    borderColor: '#2c2c2c'
  }, // yellow
  recalled: {
    text: 'Recalled',
    bgColor: '#2c2c2c',
    textColor: '#fff',
    borderColor: '#2c2c2c'
  }, // yellow
  cancelled: {
    text: 'Cancelled',
    bgColor: '#FEE2E6',
    textColor: '#E60A2B',
    borderColor: '#FCB6C0'
  },
  completed: {
    text: 'Complete',
    bgColor: '#2c2c2c',
    textColor: '#fff',
    borderColor: '#2c2c2c'
  } // yellow
};

export const TRIP_STATUS: Record<ENUM_TRIP_STATUS, any> = {
  completed: {
    text: 'Completed',
    bgColor: '#EEF9EB',
    textColor: '#46AE31',
    borderColor: '#A8E39C'
  }, // green
  failed: {
    text: 'Failed',
    bgColor: '#FEF0F2',
    textColor: '#E60A2B',
    borderColor: '#FCB6C0'
  } // red
};

export const SECURITY_PICKUP: Record<'ready' | 'pending', any> = {
  ready: {
    backgroundColor: '#7cf75c'
  }, // green
  pending: {
    backgroundColor: '#f27688'
  } // red
};

export const surgeList: SurgeListType = [
  { name: 'Mid-high traffic', val: '1.2', be_value: 'heavy-traffic' },
  {
    name: 'Rider shortage/Minor rain',
    val: '1.1',
    be_value: 'delivery-surge'
  },
  { name: 'Heavy rain', val: '1.25', be_value: 'heavy-rain' },
  { name: 'Election days', val: '1.25', be_value: 'delivery-surge' },
  { name: 'Heavy Traffic', val: '1.3', be_value: 'heavy-traffic' }
];

export const ORDER_SURGE_MINUTES = [5, 10, 15, 20, 25, 30];

export const ALL_POLYGONS_ID = 'ALL';

export const GENDER_OPTIONS = [
  { value: ENUM_GENDER.MALE, text: 'Male' },
  { value: ENUM_GENDER.FEMALE, text: 'Female' }
];

export const POLYGON_COLORS = [
  {
    color_code: '#9b5de5'
  },
  {
    color_code: '#264653'
  },
  {
    color_code: '#d90429'
  },
  {
    color_code: '#fee440'
  },
  {
    color_code: '#f15bb5'
  },
  {
    color_code: '#bc4749'
  },
  {
    color_code: '#80e47c'
  },
  {
    color_code: '#3c096c'
  },
  {
    color_code: '#0496ff'
  },
  {
    color_code: '#eb5e28'
  },
  {
    color_code: '#718355'
  },
  {
    color_code: '#f1c0e8'
  },
  {
    color_code: '#8e7dbe'
  },
  {
    color_code: '#661d44'
  },
  {
    color_code: '#5d5f76'
  },
  {
    color_code: '#23c881'
  },
  {
    color_code: '#63e448'
  },
  {
    color_code: '#3371fb'
  },
  {
    color_code: '#21a5c8'
  },
  {
    color_code: '#aa80fd'
  },
  {
    color_code: '#87ca80'
  },
  {
    color_code: '#4167cf'
  }
];

export const ORDER_ACTION = {
  CREATE: 'create-order',
  EDIT: 'edit-order'
};

export const PENDING_SOURCE: Record<ENUM_PENDING_SOURCE, any> = {
  KITCHEN: {
    text: 'KITCHEN',
    bgColor: '#EEF9EB',
    textColor: '#46AE31',
    borderColor: '#A8E39C'
  },
  REVIEW: {
    text: 'REVIEW',
    bgColor: '#FEFAEB',
    textColor: '#F9C320',
    borderColor: '#FCE08D'
  },
  LOGISTICS: {
    text: 'LOGISTICS',
    bgColor: '#EEF9EB',
    textColor: '#46AE31',
    borderColor: '#A8E39C'
  },
  CUSTOMER_SERVICE: {
    text: 'CUSTOMER_SERVICE',
    bgColor: '#F5F5F5',
    borderColor: '#DEDEDE',
    textColor: '#A3A3A3'
  },
  TECH_TEAM: {
    text: 'TECH_TEAM',
    bgColor: '#FEFAEB',
    textColor: '#F9C320',
    borderColor: '#FCE08D'
  },
  BANK_AND_FINANCE: {
    text: 'BANK_AND_FINANCE',
    bgColor: '#EEF9EB',
    textColor: '#46AE31',
    borderColor: '#A8E39C'
  },
  OTHER: {
    text: 'OTHER',
    bgColor: '#F5F5F5',
    borderColor: '#DEDEDE',
    textColor: '#A3A3A3'
  },
  FC_SHOP: {
    text: 'FC_SHOP',
    bgColor: '#FEFAEB',
    textColor: '#F9C320',
    borderColor: '#FCE08D'
  }
};

export const ORDER_TAG = {
  surge: { text: '⚡ Surge', bgColor: '#0EA3FD' }, // blue
  late: { text: '🕑 LATE', bgColor: '#E60A2B' }, // red
  runningLate: { text: '🕜 Running late', bgColor: '#F9C320' } // yellow
};

export const ITEM_TYPE_TAG = {
  FOOD: { text: 'Food', bgColor: '#0EA3FD' }, // blue
  SHOP: { text: 'Shop', bgColor: '#F9C320' } // yellow
};

export const INBOUND_ROLES: Record<ENUM_INBOUND_ROLE, any> = {
  CUSTOMER_SERVICE_INBOUND: {
    text: 'Inbound',
    bgColor: '#E6F5FF',
    textColor: '#0EA3FD',
    borderColor: '#81CFFE'
  }, // blue
  CUSTOMER_SERVICE_OUTBOUND: {
    text: 'Outbound',
    bgColor: '#FEF7E1',
    textColor: '#C69706',
    borderColor: '#FDEDBE'
  }, //yellow
  CUSTOMER_SERVICE: {
    text: 'Customer Service',
    bgColor: '#FEEBEE',
    textColor: '#F73B58',
    borderColor: '#FCBFC9'
  }, //red
  CUSTOMER_SERVICE_LEAD: {
    text: 'Lead',
    bgColor: '#EEF9EB',
    textColor: '#46AE31',
    borderColor: '#A8E39C'
  }, //
  CUSTOMER_SERVICE_ADMIN: {
    text: 'Admin',
    bgColor: '#FEFAEB',
    textColor: '#F9C320',
    borderColor: '#FCE08D'
  } //
};

export const MONTHS_OF_YEAR = [
  'Janaury',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export const CREATE_ORDER_LIST = [
  {
    name: 'Restaurants',
    emoji: '🏡'
  },
  {
    name: 'Main dish',
    emoji: '🍔'
  }
];

export const CreatOrderForm: CreateOrderFormType = {
  brandName: '',
  selectedMeal: '',
  is_group_order: false,
  basket: [],
  meal_categories: [],
  selectedMeals: {},
  deletedMeals: {}
};

export const BANK_NAMES = {
  ACCESS_BANK: 'Access Bank'
};
export const BRAND_NAMES = {
  GREEN_GOURMET: 'Green Gourmet',
  COCKTAIL_CLUB: 'The Cocktail Club'
};
export const KITCHEN_STATUS_TABS: ExtendedKitchenFilterType[] = [
  'All',
  ENUM_KITCHEN_STATUS.LATE,
  ENUM_KITCHEN_STATUS.UNPAID,
  ENUM_KITCHEN_STATUS.PROCESSING,
  ENUM_KITCHEN_STATUS.PENDING,
  ENUM_KITCHEN_STATUS.DISPATCH,
  ENUM_KITCHEN_STATUS.RECALLED
];
export const STATUS_TABS: ExtendedFilterType[] = [
  'All',
  ENUM_STATUS.ONGOING,
  ENUM_STATUS.READY,
  ENUM_STATUS.PROCESSING,
  ENUM_STATUS.PENDING,
  ENUM_STATUS.UNPAID,
  ENUM_STATUS.LATE,
  ENUM_STATUS.RECALLED
];
export const SOLD_OUT_MINUTES = [10, 20, 30, 40, 50, 60];

export const DEFAULT_TRAFFIC_SHUTDOWN_DURATIONS = [
  { value: 5, label: '5 mins' },
  { value: 10, label: '10 mins' },
  { value: 15, label: '15 mins' },
  { value: 20, label: '20 mins' },
  { value: 25, label: '25 mins' },
  { value: 30, label: '30 mins' }
];

export const KITCHEN_SCREEN_TYPE = {
  PACKAGING_TYPE: 'packaging',
  SPLIT_TYPE: 'split'
};
export const FCBBrandType = [
  { name: FCB_BRAND_TYPE.BREAKFAST, value: 'fcb_custom_breakfast' },
  { name: FCB_BRAND_TYPE.LUNCH, value: 'fcb_custom_lunch' },
  { name: FCB_BRAND_TYPE.AFTER_HOURS, value: 'fcb_custom_afterhours' }
];

export const OrderLogs = {
  [ENUM_ORDER_LOG_ACTIONS.KITCHEN_VERIFIED]: {
    name: 'Kitchen verified',
    text: 'Order received in kitchen'
  },
  [ENUM_ORDER_LOG_ACTIONS.KITCHEN_ACCEPTED]: {
    name: 'Kitchen accepted',
    text: 'Order accepted by kitchen'
  },
  [ENUM_ORDER_LOG_ACTIONS.KITCHEN_COMPLETED]: {
    name: 'Kitchen completed',
    text: 'Order completed by kitchen'
  },
  [ENUM_ORDER_LOG_ACTIONS.RIDER_ASSIGNED]: {
    name: 'Rider assigned',
    text: 'Rider has been assigned'
  },
  [ENUM_ORDER_LOG_ACTIONS.KITCHEN_DISPATCHED]: {
    name: 'Kitchen dispatched',
    text: 'Order has been dispatched '
  },
  [ENUM_ORDER_LOG_ACTIONS.RIDER_STARTED]: { name: 'Rider Started', text: 'Order is in transit' },
  [ENUM_ORDER_LOG_ACTIONS.RIDER_ARRIVED]: { name: 'Rider arrived', text: 'Rider has arrived' },
  [ENUM_ORDER_LOG_ACTIONS.ORDER_RECALLED]: {
    name: 'Order recalled',
    text: 'Order has been recalled '
  }
};
